import { render, staticRenderFns } from "./LocationList.vue?vue&type=template&id=f5babe84&scoped=true&"
import script from "./LocationList.vue?vue&type=script&lang=js&"
export * from "./LocationList.vue?vue&type=script&lang=js&"
import style0 from "./LocationList.vue?vue&type=style&index=0&id=f5babe84&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5babe84",
  null
  
)

/* custom blocks */
import block0 from "./LocationList.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5babe84')) {
      api.createRecord('f5babe84', component.options)
    } else {
      api.reload('f5babe84', component.options)
    }
    module.hot.accept("./LocationList.vue?vue&type=template&id=f5babe84&scoped=true&", function () {
      api.rerender('f5babe84', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/LocationList.vue"
export default component.exports